import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Newspaper, Calendar, Filter } from 'lucide-react';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';

const News = () => {
  const newsItems = [
    {
      id: 1,
      title: 'Nouvelles Réglementations ANJ : Ce Qui Change en 2025',
      slug: 'nouvelles-reglementations-anj-2025',
      excerpt: 'L\'Autorité Nationale des Jeux annonce de nouvelles mesures pour renforcer la protection des joueurs et améliorer la transparence des offres promotionnelles.',
      date: '30.11.2025',
      category: 'Réglementation',
      image: '/images/matthias-david-eE4hMhVmS1M-unsplash.webp',
    },
    {
      id: 2,
      title: 'Comparatif des Bonus de Bienvenue : Qui Offre le Meilleur Rapport Qualité-Prix ?',
      slug: 'comparatif-bonus-bienvenue-decembre-2025',
      excerpt: 'Notre analyse approfondie des bonus disponibles en décembre 2025 révèle des écarts significatifs entre les offres. Découvrez quels sites offrent vraiment la meilleure valeur.',
      date: '28.11.2025',
      category: 'Comparatif',
      image: '/images/alex-perez-FYD0o4Q5lXE-unsplash.webp',
    },
    {
      id: 3,
      title: 'Tendances des Paris Sportifs : Le Football Domine Mais le Tennis Gagne du Terrain',
      slug: 'tendances-paris-sportifs-novembre-2025',
      excerpt: 'Les données de paris de novembre 2025 montrent une évolution intéressante des préférences des parieurs français, avec une croissance notable des paris sur le tennis.',
      date: '25.11.2025',
      category: 'Tendances',
      image: '/images/ben-hershey-5nk3wSFUWZc-unsplash.webp',
    },
    {
      id: 4,
      title: 'Les Nouveaux Sites de Paris Arrivent en France : Quoi Surveiller ?',
      slug: 'nouveaux-sites-paris-france-2025',
      excerpt: 'Plusieurs nouveaux opérateurs ont obtenu leur agrément ANJ cette année. Analyse de leurs offres, leurs forces et leurs faiblesses pour vous aider à faire le bon choix.',
      date: '22.11.2025',
      category: 'Analyse',
      image: '/images/cameron-edwards-lLZQcmullqA-unsplash.webp',
    },
    {
      id: 5,
      title: 'Paris en Direct : Les Stratégies Gagnantes pour 2025',
      slug: 'strategies-paris-direct-2025',
      excerpt: 'Les paris en direct représentent une part croissante du marché. Découvrez les techniques les plus efficaces pour maximiser vos gains sur les paris live.',
      date: '20.11.2025',
      category: 'Stratégie',
      image: '/images/bailey-burton-o5UlVmTwVz8-unsplash.webp',
    },
    {
      id: 6,
      title: 'Impact de la Coupe du Monde sur les Paris en France',
      slug: 'impact-coupe-monde-paris-france',
      excerpt: 'Comment les grands événements sportifs transforment les habitudes de paris des Français. Analyse des tendances observées pendant les compétitions majeures.',
      date: '18.11.2025',
      category: 'Analyse',
      image: '/images/valentin-balan-9BA0Kk7-nBY-unsplash.webp',
    },
    {
      id: 7,
      title: 'Sécurité des Données : Ce Que Vous Devez Savoir',
      slug: 'securite-donnees-paris-en-ligne',
      excerpt: 'Protection de vos informations personnelles et bancaires : les bonnes pratiques et les signaux d\'alarme à surveiller sur les sites de paris.',
      date: '15.11.2025',
      category: 'Sécurité',
      image: '/images/marianna-smiley-Y4YeUSYLFsw-unsplash.webp',
    },
    {
      id: 8,
      title: 'Les Applications Mobile de Paris : Comparatif 2025',
      slug: 'applications-mobile-paris-comparatif-2025',
      excerpt: 'Quelles applications offrent la meilleure expérience utilisateur ? Notre test approfondi des principales applications de paris disponibles en France.',
      date: '12.11.2025',
      category: 'Comparatif',
      image: '/images/obscura-odessey--G4P4Q89kqc-unsplash.webp',
    },
    {
      id: 9,
      title: 'Jeu Responsable : Les Nouveaux Outils Disponibles',
      slug: 'jeu-responsable-nouveaux-outils-2025',
      excerpt: 'Les sites agréés renforcent leurs outils de protection des joueurs. Tour d\'horizon des nouvelles fonctionnalités pour jouer en toute sécurité.',
      date: '10.11.2025',
      category: 'Responsabilité',
      image: '/images/horserat-FcuE1a_pOA0-unsplash.webp',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Disclaimer />
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" data-discover="true" className="inline-flex items-center text-purple-600 hover:text-purple-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>

        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-purple-600 rounded-full mb-6">
            <Newspaper className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Actualités et Tendances des Paris en Ligne
          </h1>
          <p className="text-2xl text-gray-600 max-w-3xl mx-auto">
            Restez informé des dernières évolutions du marché français des paris en ligne
          </p>
        </div>

        {/* News grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {newsItems.map((news, index) => (
            <Link
              key={news.id}
              to={`/news/${news.slug}`}
              data-discover="true"
              itemScope
              itemType="https://schema.org/NewsArticle"
              className="bg-white rounded-xl shadow-md overflow-hidden transition-transform hover:scale-105 hover:shadow-xl"
            >
              <div className="h-48 relative overflow-hidden">
                <img 
                  src={news.image} 
                  alt={news.title}
                  itemProp="image"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/50 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-purple-600 mb-3">
                  <Calendar className="w-4 h-4" />
                  <time dateTime="2025-11-30" itemProp="datePublished">{news.date}</time>
                  <span className="text-gray-400">•</span>
                  <span className="font-semibold" itemProp="articleSection">{news.category}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" itemProp="headline">
                  {news.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed" itemProp="description">
                  {news.excerpt}
                </p>
                <div className="text-purple-600 font-semibold">
                  Lire la suite →
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* How we choose news section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-12">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <Filter className="w-6 h-6 text-purple-600" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              Comment Nous Choisissons Nos Actualités
            </h2>
          </div>
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6 leading-relaxed">
            <p>
              Dans un marché en constante évolution comme celui des paris en ligne en France, distinguer l'information pertinente du 
              simple bruit médiatique est essentiel. Notre processus de sélection des actualités repose sur une méthodologie rigoureuse 
              qui privilégie la valeur réelle pour les parieurs plutôt que le sensationnalisme ou les annonces marketing.
            </p>
            <p>
              Chaque actualité que nous publions doit répondre à un critère fondamental : apporter une information utile, vérifiable, 
              et actionnable pour nos lecteurs. Nous ne nous contentons pas de relayer les communiqués de presse ou les annonces 
              promotionnelles. Chaque information est analysée, vérifiée, et mise en contexte pour vous donner une vision claire de son 
              impact réel sur votre expérience de parieur.
            </p>
            <p>
              Notre équipe suit quotidiennement les évolutions réglementaires de l'Autorité Nationale des Jeux (ANJ), les changements 
              dans les offres des sites agréés, les tendances du marché, et les innovations technologiques. Mais nous ne publions que 
              ce qui a un impact réel. Une nouvelle réglementation qui change les règles du jeu ? Nous l'analysons en profondeur. Un 
              nouveau site qui arrive sur le marché ? Nous testons réellement son offre avant d'en parler. Une tendance émergente dans 
              les habitudes de paris ? Nous vérifions les données avant de la commenter.
            </p>
            <p>
              La transparence est au cœur de notre approche éditoriale. Quand nous comparons des offres ou analysons des tendances, 
              nous expliquons clairement nos méthodes et nos sources. Nous ne recommandons jamais un site ou une stratégie sans l'avoir 
              personnellement testée et validée. Nos analyses sont basées sur des faits vérifiables, pas sur des opinions ou des 
              partenariats commerciaux.
            </p>
            <p>
              Nous privilégions également la diversité des sujets pour couvrir tous les aspects qui intéressent les parieurs : les 
              réglementations et leurs impacts, les comparaisons d'offres et de services, les stratégies et techniques de paris, les 
              tendances du marché, la sécurité et la protection des joueurs, et les innovations technologiques. Chaque actualité est 
              choisie pour compléter votre compréhension du monde des paris en ligne, pas pour faire du clic ou de la publicité déguisée.
            </p>
            <p>
              Enfin, nous actualisons régulièrement nos contenus pour refléter les changements. Une actualité sur les bonus peut devenir 
              obsolète en quelques semaines si les offres changent. Nous suivons ces évolutions et mettons à jour nos articles en 
              conséquence. Notre objectif n'est pas de publier le plus d'articles possible, mais de publier les articles les plus utiles 
              et les plus à jour possible.
            </p>
            <p>
              Cette approche rigoureuse garantit que chaque actualité que vous lisez sur Lyon Picks vous apporte une valeur réelle : 
              une information que vous pouvez utiliser pour améliorer vos décisions, comprendre les évolutions du marché, ou simplement 
              rester informé des changements qui affectent votre expérience de parieur. Nous croyons qu'un parieur bien informé est un 
              parieur qui fait de meilleurs choix, et c'est cette conviction qui guide notre sélection éditoriale chaque jour.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default News;

